import { useReducer } from 'react';

type LoadingState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'success' }
  | { status: 'error'; error?: string };

type LoadingAction =
  | { type: 'START_LOADING' }
  | { type: 'FETCH_SUCCESS' }
  | { type: 'FETCH_ERROR'; error?: string }
  | { type: 'RESET' };

const initialState: LoadingState = { status: 'idle' };

function loadingReducer(state: LoadingState, action: LoadingAction): LoadingState {
  switch (action.type) {
    case 'START_LOADING':
      return { status: 'loading' };
    case 'FETCH_SUCCESS':
      return { status: 'success' };
    case 'FETCH_ERROR':
      return { status: 'error', error: action.error };
    case 'RESET':
      return { status: 'idle' };
    default:
      return state;
  }
}

export const useFetchLoading = () => {
  const [state, dispatch] = useReducer(loadingReducer, initialState);

  return {
    state,
    isLoading: state.status === 'loading',
    isSuccess: state.status === 'success',
    isError: state.status === 'error',
    error: state.status === 'error' ? state.error : undefined,
    startLoading: () => dispatch({ type: 'START_LOADING' }),
    setSuccess: () => dispatch({ type: 'FETCH_SUCCESS' }),
    setError: (error?: string) => dispatch({ type: 'FETCH_ERROR', error }),
    reset: () => dispatch({ type: 'RESET' }),
  };
};
